var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getWindow } from '../../../utils/general';
export var PHTableHeaderData = function (isAdminRole, pHRequest, searchByObj, selectedHeader, setPHRequest, sortDirection, tableHeaderState) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var lineItemData = Object.prototype.hasOwnProperty.call(searchByObj, 'itemDescription');
    if (lineItemData) {
        // Line Item Data
        return [
            {
                title: 'Date',
                style: { width: '90px' },
                sort: false,
                sortProps: {
                    sortDirection: '',
                    ariaLabel: '',
                    active: false,
                    direction: undefined,
                    padding: '',
                    onClick: function () { return null; },
                    style: {},
                },
                showHeader: true,
            },
            {
                title: 'Item',
                style: { width: '70px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Description',
                style: { width: '155px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Order #',
                style: { width: '119px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Receipt #',
                style: { width: '119px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Qty',
                style: { width: '48px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Unit Price',
                style: { width: '106px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Discount',
                style: { width: '89px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Net Unit Price',
                style: { width: '115px' },
                sort: false,
                showHeader: true,
            },
        ];
    }
    return [
        {
            title: 'Products',
            style: { width: '132px' },
            sort: false,
            showHeader: (_a = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[0]) === null || _a === void 0 ? void 0 : _a.enabled,
        },
        {
            title: 'Order/Receipt #',
            style: { width: '132px' },
            sort: true,
            sortProps: {
                sortDirection: selectedHeader === 'orderNumber' ? sortDirection : undefined,
                ariaLabel: 'Sort by order number',
                active: selectedHeader === 'orderNumber',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'orderNumber', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_b = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[1]) === null || _b === void 0 ? void 0 : _b.enabled,
        },
        {
            title: 'Date',
            style: { width: '100px' },
            sort: true,
            sortProps: {
                sortDirection: selectedHeader === 'salesDate' ? sortDirection : undefined,
                ariaLabel: 'Sort by sales date',
                active: selectedHeader === 'salesDate',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'salesDate', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_c = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[2]) === null || _c === void 0 ? void 0 : _c.enabled,
        },
        {
            title: 'Origin',
            style: { width: '101px' },
            sort: true,
            sortProps: {
                sortDirection: selectedHeader === 'storeNumber' ? sortDirection : undefined,
                ariaLabel: 'Sort by store number',
                active: selectedHeader === 'storeNumber',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'storeNumber', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_d = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[3]) === null || _d === void 0 ? void 0 : _d.enabled,
        },
        {
            title: 'PO/Job Name',
            style: { width: '124px' },
            sort: true,
            sortProps: {
                sortDirection: selectedHeader === 'POJobName' ? sortDirection : undefined,
                ariaLabel: 'Sort by POJobName',
                active: selectedHeader === 'POJobName',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'POJobName', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px', textAlign: 'left' },
            },
            showHeader: (_e = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[4]) === null || _e === void 0 ? void 0 : _e.enabled,
        },
        {
            title: 'Payment',
            style: { width: '128px' },
            sort: true,
            sortProps: {
                sortDirection: selectedHeader === 'totalAmount' ? sortDirection : undefined,
                ariaLabel: 'Sort by total amount',
                active: selectedHeader === 'totalAmount',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'totalAmount', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_f = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[5]) === null || _f === void 0 ? void 0 : _f.enabled,
        },
        {
            title: 'Purchaser',
            style: { width: '112px', textAlign: 'left' },
            sort: false,
            isAdmin: isAdminRole,
            showHeader: (_g = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[6]) === null || _g === void 0 ? void 0 : _g.enabled,
        },
        {
            title: 'Nickname',
            style: { width: '112px', textAlign: 'left' },
            sort: false,
            showHeader: (_h = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[7]) === null || _h === void 0 ? void 0 : _h.enabled,
        },
        {
            title: 'Total',
            style: { width: '97px' },
            sort: true,
            sortProps: {
                sortDirection: selectedHeader === 'totalAmount' ? sortDirection : undefined,
                ariaLabel: 'Sort by total amount',
                active: selectedHeader === 'totalAmount',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'totalAmount', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_j = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[8]) === null || _j === void 0 ? void 0 : _j.enabled,
        },
    ];
};
export var PHTableHeaderValues = function () {
    var _a, _b, _c;
    var tableHeaderValuesLocalStorage = (_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.getItem('tableHeaders')) !== null && _c !== void 0 ? _c : '';
    if (tableHeaderValuesLocalStorage !== '') {
        var tableHeaderValues = JSON === null || JSON === void 0 ? void 0 : JSON.parse(tableHeaderValuesLocalStorage);
        return tableHeaderValues;
    }
    return [
        {
            columnName: 'Product Images',
            enabled: true,
        },
        {
            columnName: 'Order/Receipt Number',
            enabled: true,
        },
        {
            columnName: 'Date',
            enabled: true,
        },
        {
            columnName: 'Origin (Location of Purchase)',
            enabled: true,
        },
        {
            columnName: 'PO/Job Name',
            enabled: true,
        },
        {
            columnName: 'Payment',
            enabled: true,
        },
        {
            columnName: 'Purchaser/Buyer',
            enabled: true,
        },
        {
            columnName: 'Nickname (Payment Nickname)',
            enabled: true,
        },
        {
            columnName: 'Total',
            enabled: true,
        },
    ];
};
